export function ubtoa(str) {
  try {
    return window.btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
        return String.fromCharCode("0x" + p1);
      })
    );
  } catch (e) {
    //checkstr1(str)
    //return base64ArrayBuffer(str);
    return window.btoa(unescape(encodeURIComponent(str)));
  }
}
